// CKEditor plugin to apply links to URLs in plain-text pastes
const URL_REGEXP = /\b(https?|ftp):\/\/(-\.)?([^\s\/?\.#]+\.?)+(\/[^\s]*)?[^\s\.,]\b/ig;
const EMAIL_REGEXP = /\b[a-zA-Z0-9.!#$%&'*+\/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*\b/g;

export const linkifyPastesPlugin = {
  requires: 'clipboard,textmatch',
  init(editor) {
    const urlTemplate = new CKEDITOR.template('<a href="{link}">{text}</a>');
    const emailTemplate = new CKEDITOR.template('<a href="mailto:{link}">{text}</a>');

    const pasteCallback = function(evt) {
      if (evt.data.dataTransfer.getTransferType(editor) === CKEDITOR.DATA_TRANSFER_INTERNAL) { return; }

      const data = evt.data.dataValue;

      // Parse the HTML using CKEDITOR, so we can transform standalone text not in a link.
      const fragment = CKEDITOR.htmlParser.fragment.fromHtml(data);
      const writer = new CKEDITOR.htmlParser.basicWriter();

      fragment.forEach(function(node) {
        if (node instanceof CKEDITOR.htmlParser.text) {
          if (!node.getAscendant('a')) {
            // Not in a link, so ok to replace.
            const textData = node.value;
            let linkifiedData = textData.replace(URL_REGEXP, (match) => urlTemplate.output({ text: match, link: match }));
            linkifiedData = linkifiedData.replace(EMAIL_REGEXP, (match) => emailTemplate.output({ text: match, link: match }));

            if (textData !== linkifiedData) {
              const newNode = CKEDITOR.htmlParser.fragment.fromHtml(linkifiedData);
              return node.replaceWith(newNode);
            }
          }
        }
      });

      fragment.writeHtml(writer);

      const linkifiedData = writer.getHtml();

      if (linkifiedData !== data) {
        evt.data.dataValue = linkifiedData;
        return evt.data.type = 'html';
      }
    };

    return editor.on('paste', pasteCallback);
  }
};
